export default function FormErrorMessage({ children }) {
  if (!children) return null;

  return <div className="text-sm text-red-500">{children}</div>;
}
